/**
 * Runtime-config (`assets/config.json`) shapes for the Angular frontends.
 *
 * `BaseFrontendConfig` is the part BOTH apps' config.json genuinely carries
 * (service endpoints + Keycloak client). The app builder's own additions live in
 * `WorkflowFrontendConfig`
 * (apps/finxone-workflow-frontend/src/app/libs/services/config-service/config.type.ts),
 * which extends the base declared here.
 *
 * Two constraints shape this file and must be kept:
 *  1. It stays IMPORT-FREE — the provisioner's config-schema generator
 *     (apps/provisioner-service/src/deployment/config-schema/generate-web-frontend-schema.ts)
 *     parses it standalone, outside the Angular tsconfig/module graph. That is why
 *     the shared base lives here rather than in a lib under libs/.
 *  2. `WebFrontendConfig` re-declares the base fields instead of extending, because
 *     that generator reads declared members only; `implements BaseFrontendConfig`
 *     makes tsc enforce the two stay in parity.
 */
export class BaseFrontendConfig {
  'api_endpoints'!: any;
  auth!: AuthConfig;
}

export class AuthConfig {
  realm!: string;
  client_id!: string;
}

export class WebFrontendConfig implements BaseFrontendConfig {
  'api_endpoints'!: any;
  auth!: AuthConfig;
  novuApplicationIdentifier?: string;
  idleTimeout?: number;
  addSafeAreaPadding?: boolean;
  features?: {
    bfCacheAlertDetection?: boolean;
    redirectForApplePayEnabled?: boolean;
    deviceEnrollmentEnabled?: boolean;
    customWidgetBrowserCapabilitiesEnabled?: boolean;
  };
  customWidgetEdge?: {
    baseUrl: string;
    route: string;
  };
  googleMeasurementId?: string;
  googleTagManagerId?: string;
  goCardlessEnvironment?: string;
  goCardlessEnabledCustomPaymentPages?: boolean;
  goCardlessCustomPaymentRedirectUri?: string;
  appDeepLinkUrl?: string;
  overrideGoCardlessDevModeForAISP?: boolean;
  cloudflareTurnstileSiteKey?: string;
  cookiebotId?: string;
}
